import { CompositeKeys } from './composite-keys';
import { KeyActionName } from './key-action-names';
import { KeyEventType } from './key-event-type';

export interface IKeyEventMessage {
  hotKey: string;
  compositeKeys: CompositeKeys[];
  eventType: KeyEventType;
}

export interface IKeyEventData extends IKeyEventMessage {
  suitableActionNames: KeyActionName[];
}
